import { Box, Button, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TotalBudgetSummary } from 'pages/calculator/MediaPlanning/Plan/Countries/NestedCountryTabs/CountryPlanSummary/TotalBudgetSummary/TotalBudgetSummary';
import DigitalBudgetTable from 'pages/calculator/MediaPlanning/common/BudgetTable/DigitalBudgetTable/DigitalBudgetTable';
import OfflineBudgetTable from 'pages/calculator/MediaPlanning/common/BudgetTable/OfflineBudgetTable/OfflineBudgetTable';
import usePlanStore from 'store/planStore';
import { groupCalculatedBudgetTouchpointData } from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/groupTouchpointData';
import useGenerateXls from '../../../PlanSummary/hooks/useGenerateXls';

function CountryPlanSummary() {
  const { t } = useTranslation();
  const { countryForms, savedCountryForms, selectedCountry } = usePlanStore();
  if (
    !selectedCountry ||
    (!countryForms[selectedCountry].savedCalculatedBudget?.length &&
      !countryForms[selectedCountry].offline?.tv?.offlineBudget)
  ) {
    return (
      <Box sx={{ p: '16px 21px 50px 21px' }}>
        <Typography color="error">
          {t('mediaPlanning.noCalculatedBudget')}
        </Typography>
      </Box>
    );
  }

  const savedForm = savedCountryForms[selectedCountry!];
  const ytConfig = savedForm?.youTubeConfig;
  const metaConfig = savedForm?.metaConfig;
  const tiktokConfig = savedForm?.tiktokConfig;
  const goldenRuleMap = {
    META: {
      grReach: metaConfig?.grReach,
      isGoldenRuleMet: metaConfig?.isGoldenRuleMet,
      reach: metaConfig?.saturationMin
        ? (metaConfig?.reachEstimateMin ?? 0) * (metaConfig?.saturation ?? 0)
        : 0,
    },
    YOUTUBE: {
      grReach: ytConfig?.grReach,
      isGoldenRuleMet: ytConfig?.isGoldenRuleMet,
      reach: ytConfig?.saturationMin
        ? (ytConfig?.targetGroup?.targetSizePopulation ?? 0) *
          (ytConfig?.saturation ?? 0)
        : 0,
    },
    TIKTOK: {
      grReach: tiktokConfig?.grReach,
      isGoldenRuleMet: tiktokConfig?.isGoldenRuleMet,
      reach: tiktokConfig?.saturationMin
        ? (tiktokConfig?.targetGroup?.targetSizePopulation ?? 0) *
          (tiktokConfig?.saturation ?? 0)
        : 0,
    },
  };

  const processedData = countryForms[
    selectedCountry!
  ]?.offline?.tv?.offlineBudget?.map((budget) => {
    if (budget.touchpoint !== 'outdoor') {
      return budget;
    }

    return {
      ...budget,
      children:
        budget.children?.filter((child) => child.isIncludedInCalculations) ||
        [],
    };
  });

  return (
    <Box
      sx={{
        pt: '17px',
        pb: '50px',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '40px',
      }}
    >
      <TotalBudgetSummary
        digital={countryForms[selectedCountry].savedCalculatedBudget}
        offline={countryForms[selectedCountry]?.offline?.tv?.offlineBudget}
      />
      <DigitalBudgetTable
        data={groupCalculatedBudgetTouchpointData(
          countryForms[selectedCountry]?.savedCalculatedBudget || []
        )}
        goldenRuleMap={goldenRuleMap}
      />
      <OfflineBudgetTable data={processedData || []} />
    </Box>
  );
}

export default CountryPlanSummary;
